import BackspaceCommand from './backspace';
import CommandResult from './command-result';
export default BackspaceCommand.extend({
  processZeroWidth() {
    if (this.get('firstSelectedBlock.isMedia')) {
      return this._deleteMediaBlock();
    }
    if (this._selectionIsAtEndOfBlock()) {
      return this._zeroWidthAtEndOfBlock();
    }
    if (this._selectionIsAtEndOfItem()) {
      return this._zeroWidthAtEndOfItem();
    }
    this.expandSelectionRightBy(1);
    let result = this.applyActionToFirstSelectedBlock('delete');
    if (result.get('updatesCaret')) {
      this.setSelectionToPositionIndex(result.get('blockRange.startPoint.positionIndex'));
    }
    this.collapseSelection();
    return CommandResult.create({
      shouldRerender: true
    });
  },
  _zeroWidthAtEndOfBlock() {
    if (this.get('nextBlock.isMedia')) {
      if (this.get('firstSelectedBlock.isEmpty')) {
        this.removeFirstSelectedBlock();
      }
      this.setSelectionToEndOf(this.get('nextBlock'));
      return CommandResult.create({
        shouldRerender: false
      });
    }
    if (this.get('nextBlock')) {
      return this._joinNextBlock();
    }
  },
  _zeroWidthAtEndOfItem() {
    return this._delegateToFirstSelectedBlock();
  },
  _deleteMediaBlock() {
    let result = this._super();
    if (this.get('nextBlock')) {
      this.setSelectionToStartOf(this.get('nextBlock'));
    }
    return result;
  },
  _joinNextBlock() {
    let mutationResult = this.get('firstSelectedBlock').join(this.get('nextBlock'));
    this.removeBlocks(mutationResult.get('blocksToRemove'));
    return CommandResult.create({
      shouldRerender: true
    });
  },
  _delegateToFirstSelectedBlock() {
    let blockList, selection;
    blockList = this.get('firstSelectedBlock.blockList');
    selection = this.get('firstSelectedBlockItemSelection');
    selection.set('blockList', blockList);
    return this.constructor.create({
      blockList,
      selection,
      config: this.get('config')
    }).run();
  },
  _selectionIsAtEndOfBlock() {
    if (this.get('firstSelectedBlock.isListType')) {
      return this.get('selection.startItemIndex') === this.get('firstSelectedBlock.blockList.length') - 1 && this._selectionIsAtEndOfItem();
    } else {
      return this.get('selection.startPositionIndex') === this.get('firstSelectedBlock.text.length');
    }
  },
  _selectionIsAtEndOfItem() {
    if (!this.get('firstSelectedBlock.isListType')) {
      return false;
    }
    let itemIndex = this.get('selection.startItemIndex');
    let selectedItem = this.get('firstSelectedBlock.blockList').objectAt(itemIndex);
    return this.get('selection.startPositionIndex') === selectedItem.get('text.length');
  }
});